import { z } from 'zod';
import { Collection, PropertyType } from '@varos/research-sdk-api';
import { assertNever } from '@varos/util-typescript';

export function createRecordFormZodSchema(item: { collection: Collection }) {
    function buildTypeSchema(type: PropertyType) {
        if (type === 'string') {
            return z.string();
        }
        if (type === 'text') {
            return z.string();
        }
        if (type === 'email') {
            return z.string().email();
        }
        if (type === 'rating') {
            return z.number().min(0).max(5);
        }
        if (type === 'integer') {
            return z.number().int();
        }
        if (type === 'float') {
            return z.number();
        }
        if (type === 'boolean') {
            return z.boolean().default(false);
        }
        if (type === 'date') {
            return z.date();
        }
        if (type === 'datetime') {
            return z.date();
        }
        if (type === 'link') {
            return z.string();
        }
        if (type === 'relation') {
            return z.string();
        }
        if (type === 'enum') {
            return z.string();
        }
        if (type === 'user') {
            return z.string();
        }
        if (type === 'snippet') {
            return z.string();
        }
        assertNever(type);
    }
    return z.object({
        title: z.string().nullable().optional(),
        properties: z.object(
            item.collection.properties.reduce(
                (acc, property) => {
                    let baseSchema: z.ZodTypeAny = buildTypeSchema(property.type);
                    if (!property.required) {
                        baseSchema = baseSchema.nullable().optional();
                    }
                    return {
                        ...acc,
                        [property.key]: baseSchema,
                    };
                },
                {} as Record<string, z.ZodTypeAny>
            )
        ),
    });
}
